<template>
    <div>
        <h2>Portal Mobile API Documentation</h2>
        <div class="download-link-container">
            <ul v-if="docFiles.length">
                <li
                    v-for="(file, fileIndex) in docFiles"
                    :key="fileIndex"
                    :data-test-id="`file-${fileIndex}`"
                >
                    <button
                        type="button"
                        class="btn btn-primary btn-medium"
                        :title="`Download ${file}`"
                        :data-test-id="`file-download-link-${fileIndex}`"
                        @click.prevent="downloadFile(file)"
                    >
                        <span class="icon-export download-link-container__icon" />
                        {{ file }}
                    </button>
                </li>
            </ul>
            <span v-else>There are no documents to view</span>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            docFiles: [],
        }
    },

    mounted() {
        this.getFiles()
    },

    methods: {
        downloadFile(file) {
            this.$http
                .get(`/developers/api-documents/download?filename=${file}`, {
                    responseType: 'blob',
                })
                .then((response) => {
                    // create file link in browser's memory
                    const href = URL.createObjectURL(response.data)

                    // create "a" HTML element with href to file & click
                    const link = document.createElement('a')
                    link.href = href
                    link.setAttribute('download', file)
                    document.body.appendChild(link)
                    link.click()

                    // clean up "a" element & remove ObjectURL
                    document.body.removeChild(link)
                    URL.revokeObjectURL(href)
                })
        },
        getFiles() {
            this.$http.get(`/developers/api-documents`).then((response) => {
                this.docFiles = response.data.files
            })
        },
    },
}
</script>

<style scoped>
.download-link-container {
    margin-top: 2ex;

    ul > li {
        display: flex;
        align-items: center;
        gap: 12px;
        margin-bottom: 1.5ex;
    }
}
</style>
